import { useCallback } from "react";
import { useDispatch } from "react-redux";

import { AppDispatch } from "store/store";

import { setGridMode } from "./emissionsStore";
import { GridMode } from "./types";

export interface UseTaskDetailsSetters {
  setGridMode: (gridMode: GridMode) => void;
}

export const useEmissionsStore = (): UseTaskDetailsSetters => {
  const dispatch = useDispatch<AppDispatch>();

  return {
    setGridMode: useCallback(
      (mode: GridMode) => dispatch(setGridMode(mode)),
      [dispatch]
    ),
  };
};
